/* eslint-disable no-dupe-keys */
/* eslint-disable max-len */

export default {
  en: {
    common: {
      dashboard: "Dashboard",
      editModel: "Edit %{model}",
      newModel: "New %{model}",
      confirmDiscardChanges: "Are you sure you want to discard your changes?",
      ticket: "Ticket",
      checkins: "Checkins",
      quantity: "Quantity",
      event: "Event",
      price: "Price",
      import: "Import",
      loading: "Loading...",
      analytics: "Analytics",
      tableSettings: "Table Settings",
      paymentMethods: "Payment Methods",
      done: "Done",
      confirm: "Confirm",
      downloadExcel: "Download Excel",
      downloadCodeReadr: "Download CodeReadr",
      search: "Search",
      fees: "Fees",
      viewDetails: "View Details",
      cancelled: "Cancelled",
      uncancelled: "Uncancelled",
      checkedIn: "Checked-In",
      valid: "Valid",
      notCheckedIn: "Not Checked-In",
      checkOut: "Check Out",
      checkIn: "Check In",
      perPage: "per page",
      cancelTicket: "Cancel Ticket",
      uncancelTicket: "Uncancel Ticket",
      name: "Name",
      email: "Email",
      mobile: "Mobile Number",
      seat: "Seat",
      ticketNumber: "Ticket Number",
      orderNumber: "Order Number",
      ticketStatus: "Ticket Status",
      filterTickets: "Filter Tickets",
      tags: "Tags",
      cancel: "Cancel",
      vatIncluded: "VAT included",
      free: "Free",
      section: "Section",
      row: "Row",
      ticketholder: "Ticketholder",
      seriesNumber: "Series Number",
      merchant: "Merchant",
      vatNumber: "VAT Number",
      downloadTicket: "Download Ticket",
      printTicket: "Print Ticket",
      attendees: "Attendees",
      new: "New",
      ticketTypes: "Ticket Types",
      cancelText: "I understand that this operation cannot be reversed.",
      badges: "Badges",
      amount: "Amount",
      update: "Update",
      create: "Create",
      discounts: "Discounts",
      image: "Image",
      hidden: "Hidden",
      available: "Available",
      coverPhoto: "Cover Photo",
      termsAndConditions: "Terms and Conditions",
      donations: "Donations",
      eventId: "Event ID",
      subject: "Subject",
      canUseVariables: "You can use variables in message",
      recommendedSize: "Recommended image size of 1920px width by 640px height in JPG format.",
      description: "Description",
      currency: "Currency",
      category: "Category",
      visibility: "Visibility",
      eventProfile: "Event Profile",
      public: "Public",
      back: "Back",
      report: "Report",
      private: "Private",
      chooseFile: "Choose File...",
      operaSettings: "Opera Settings",
      walletSettings: "Wallet Settings",
      marketPlace: "Marketplace",
      firstName: "First Name",
      lastName: "Last Name",
      tax_id: "Tax ID",
      gender: "Gender",
      continue: "Continue",
      addAttendees: "Add Attendees",
      importAttendees: "Import Attendees",
      importSummary: "Import Summary",
      filterInvoices: "Filter Invoices",
      paymentMethod: "Payment Method",
      all: "All",
      filter: "Filter",
      logo: "Logo",
      role: "Role",
      link: "Link",
      ok: "OK",
      partners: "Partners",
      confirmPayment: "Confirm Payment",
      save: "Save",
      paymentSettings: "Payment Settings",
      browse: "Browse",
      add: "Add",
      hide: "Hide",
      unhide: "Unhide",
      settings: "Settings",
      reserveSeats: "Reserve Seats",
      templates: "Templates",
      type: "Type",
      and: "and",
      none: "None",
      country: "Country",
      city: "City",
      nationality: "Nationality",
      zipCode: "Zip Code",
      venue: "Venue",
      tickets: "Tickets",
      invoices: "Invoices",
      orders: "Orders",
      editProfile: "Edit Profile",
      address: "Address",
      map: "Map",
      customer: "Customer",
      locateAutomatically: "Locate Automatically",
      pinOnMap: "Pin on map",
      merchantProfile: "Merchant Profile",
      teammates: "Teammates",
      next: "Next",
      total: "Total",
      yearly: "Yearly",
      monthly: "Monthly",
      daily: "Daily",
      hourly: "Hourly",
      perMinute: "Per Minute",
      edit: "Edit",
      // shared UI components
      clickToUpload: "Click here to upload",
      destroy: "Destroy",
      undestroy: "Undestroy",
      remove: "Remove",
      noItemsCreated: "No items created.",
      noResourceCreated: "There are no %{item} for this event.",
      createNewResource: "Create a new %{item}",
      seatingMap: "Seating Map",
      selectTemplate: "Select Template",
      selectTopupTemplate: "Select Topup Template",
      selectSettlementTemplate: "Select Settlement Template",
      selectInvoiceTemplate: "Select Invoice Template",
      seconds: "Seconds",
      minutes: "Minutes",
      hours: "Hours",
      days: "Days",
      activateTag: "Activate Tag",
      seatingOverview: "Seating Overview",
      from: "From",
      select: "Select",
      all: "All",
      none: "None",
      station: "Station",
      connectedAccount: "Connected Account",
      totalSales: "Total Sales",
      netProceeds: "Net Proceeds",
      totalFees: "Total Fees",
      action: "Action",
      totalSettlements: "Total Settlements",
      balance: "Balance",
      settlementAmount: "Settlement Amount"
    },
    invoice: {
      number: "Invoice Number"
    },

    invoice_report: {
      invoice_start: "Invoice Date Start",
      invoice_end: "Invoice Date End",
      payment_start: "Payment Date Start",
      payment_end: "Payment Date End"
    },
    sidebar: {
      dates: "Dates",
      import: "Import",
      fees: "Fees",
      inventory: "Inventory",
      orderSettings: "Order Settings",
      registrationForm: "Registration Form",
      preview: "Preview",
      emailAttendees: "Email Attendees",
      merchantSettings: "Merchant Settings",
      merchantAccount: "Merchant Account",
      paymentMethods: "Payment Methods",
      userAccount: "User Account",
      userProfile: "User Profile",
      changePassword: "Change Password",
      logout: "Logout",
      events: "Events"
    },
    fee: {
      model: "Fee",
      name: "Name",
      fees: "Fees",
      settings: "Fee Settings",
      service: "Service",
      absorbOrPassOn: "Absorb / Pass On",
      fixed: "Fixed Fee",
      variable: "Variable Fee",
      minimum: "Minimum Fee",
      maximum: "Maximum Fee",
      noFees: "No fees created.",
      mapDisplay: "Fee Map Display",
      engMap: "English Fee Map Display",
      arMap: "Arabic Fee Map Display",
      ticketing: "Ticketing",
      invoicing: "Invoicing",
      topup: "Topup",
      refund: "Refund"
    },
    event: {
      model: "Event",
      upcoming: "Upcoming",
      draft: "Draft",
      past: "Past",
      manage: "Manage",
      view: "View",
      search: "Search",
      overview: "Event Overview",
      name: "Event Name",
      cover: "Cover",
      properties: "Properties",
      country: "Country",
      timeZone: "Time Zone",
      listing: "Listing",
      addTag: "Add Tag",
      public: "Public",
      ticketButtonText: "Get Ticket Button Text",
      dateSelector: "Date Selector",
      customEventProfileDate: "Custom Event Profile Date String",
      customConfirmation: "Custom Confirmation Email",
      customBooking: "Custom Booking Email",
      customRefund: "Custom Refund Email",
      getTickets: "Get Tickets",
      register: "Register",
      donate: "Donate",
      requestInvite: "Request Invite",
      requestTable: "Request Table",
      wallet: "Wallet",
      topup: "Top Up",
      subscribe: "Subscribe",
      continue: "Continue",
      bookSeat: "Book your Seat",
      addFund: "Add Funds",
      buttons: "Buttons",
      calendar: "Calendar",
      activity: "Activity",
      bootcamp: "Bootcamp",
      cinema: "Cinema",
      comedy: "Comedy",
      classes: "Classes",
      clubbing: "Clubbing",
      concert: "Concert",
      conference: "Conference",
      esports: "Esports",
      exhibition: "Exhibition",
      fair: "Fair",
      festival: "Festival",
      package: "Package",
      party: "Party",
      performance: "Performance",
      private: "Private",
      screening: "Screening",
      seminar: "Seminar",
      show: "Show",
      sports: "Sports",
      subscription: "Subscription",
      tourism: "Tourism",
      theatre: "Theatre",
      wedding: "Wedding",
      workshop: "Workshop",
      selectOne: "Select One"
    },
    venue: {
      model: "Venue",
      name: "Name",
      street: "Street",
      building: "Building",
      map: "Venue Map",
      auto: "Locate Automatically",
      pin: "Pin on Map",
      hide: "Hide"
    },
    eventDate: {
      model: "Event Date",
      date: "Date",
      datePluralized: "{count} Dates | {count} Date | {count} Dates",
      start: "Start",
      end: "End",
      startDate: "Start Date",
      endDate: "End Date",
      customDate: "Custom Date",
      range: "Date Range",
      starts: "Starts",
      ends: "Ends",
      hideShow: "Hide/Show",
      hidden: "Hidden",
      customText: "Custom Date",
      downloadSample: "Download Sample File",
      customDisplay: "Custom Display",
      customFormat: "Custom Date Format",
      displayCustomDate: "Display Custom Date",
      select: "Select Date",
      customFormatDisclaimer: "Add a custom date format to override how the default date range is displayed to buyers online and on tickets.",
      customDateLabel: "Custom Date Label",
      import: "Import",
      importDates: "Import Dates",
      excelFile: "Excel File",
      confirmImport: "Confirm",
      invalid: "Invalid Dates",
      rowNumber: "Row #",
      errorReason: "Reason",
      cancel: {
        title: "Cancel Date",
        text: "I understand all %{count} tickets will be cancelled and refunded when applicable.",
        body: `%{count} tickets were sold or issued for this date.<br>
              By cancelling this date, all tickets will be cancelled and purchases refunded to buyers.<br>
              Buyers will be immediately notified of the cancellation.<br>
              This action cannot be reverted!<br>
              If you no longer want to sell tickets for this date without cancelling existing purchases, you can hide it or mark it as sold out.`
      }
    },
    ticketType: {
      model: "Ticket Type",
      pluralized: "{count} Ticket Types | {count} Ticket Type | {count} Ticket Types",
      name: "Name",
      price: "Price",
      date: "Date",
      status: "Status",
      progress: "Progress",
      settings: "Settings",
      advanced: "Advanced",
      webhooks: "Webhooks",
      dates: "Dates",
      datesDisclaimer: "This ticket type will be available for sale for any of the selected event dates.",
      priceDisclaimer: "Your ticket price must include all applicable taxes.",
      addVat: "Add a VAT#",
      toMerchantAccount: "to your merchant account.",
      includingVat: "Including VAT",
      fees: "Fees",
      feesDisclaimer: "Absorb or pass-on ticketing fees to the buyer.",
      buyerPays: "Buyer Pays",
      organizerPays: "Organizer Pays",
      quantity: "Quantity",
      quantityDisclaimer: "The system considers the set quantity to be available for each event date.",
      sections: "Sections",
      advancedSettings: "Advanced Settings",
      availableFrom: "Available for Sale From",
      availableUntil: "Available for Sale Until",
      accessCode: "Access Code",
      accessDisclaimer: "Only allow people with this access code to book this ticket type.",
      limitTickets: "Limit Tickets per Order Between",
      preselectedTickets: "Preselected Number of Tickets",
      showTicket: "Show Ticket",
      showPrice: "Show Ticket Price",
      markSoldOut: "Mark as Sold Out",
      sendInvitationEmail: "Send Invitation Email",
      sendEventReminder: "Send Event Reminder",
      customConditions: "Custom Conditions",
      customCheckinSms: "Custom Checkin SMS",
      availableVariables: "Available Variables:",
      dynamicWhitelist: "Dynamic Whitelist",
      salesMode: {
        label: "Sales Mode",
        default: "Default",
        static: "Static",
        relative: "Relative"
      },
      salesStartDate: "Sales Start Date",
      salesEndDate: "Sales End Date",
      cover: {
        label: "Cover Photo",
        sourceEvent: "Use event cover photo",
        sourceCustom: "Custom Cover Photo",
        blank: "Blank"
      },
      cancel: {
        title: "Cancel Ticket Type",
        text: "I understand all %{count} tickets will be cancelled and refunded when applicable.",
        body: `%{count} %{name} tickets were sold or issued.<br>
        By cancelling, this ticket type, all tickets will be cancelled.<br>
        You will have to refund all cancelled tickets paid by your attendees or issue replacement tickets to them.<br>
        Buyers will be immediately notified of the cancellation. This action cannot be reverted!<br>
        If you no longer want to sell this ticket type without cancelling existing purchases, you can hide it or mark it as sold out.`
      }
    },
    webhook: {
      model: "Webhook",
      pluralized: "{count} Webhooks | {count} Webhook | {count} Webhooks",
      name: "Name",
      url: "URL",
      method: "METHOD",
      format: "FORMAT",
      settings: "Webhook Settings",
      requestMethod: "Request Method",
      requestFormat: "Request Format",
      enabled: "Enabled",
      header: "Header",
      query: "Query",
      body: "Body",
      key: "Key",
      value: "Value",
      triggerAction: "On Action"
    },
    pagination: {
      first: "First",
      last: "Last"
    },
    attendee: {
      model: "Attendee",
      valid: "Valid",
      downloadBadge: "Download %{badgeName}",
      badgeNumber: "Badge #%{number}",
      printBadge: "Print %{badgeName}",
      pluralized: "{count} Attendees | {count} Attendee | {count} Webhooks",
      uncancel: "Uncancel",
      cancel: {
        text: "Cancelling the ticket will not cancel the order and any associated payment information. This may create discrepancies in your reports.",
        body: `Cancel Ticket will keep the order as paid<br>
              Cancel Order will cancel all tickets in the order and mark the order as refundable`
      },
      cancelOrder: "Cancel Order",
      print: "Print",
      noBadges: "No badges found for this ticket",
      ticketPaidAt: "Ticket Paid At",
      invalidUsers: "Invalid Users",
      numberOfImportedUsers: "Number of Imported Users: %{count}",
      numberOfCreatedOrders: "Number of Created Orders: %{count}",
      reimportNotice: "After correcting the invalid information please re-import the attendees in a separate Excel sheet or add them manually.",
      importPartialSuccess: "The import was partially successful. Some orders were not created because the users displayed below have invalid data.",
      importSuccess: "All attendees were successfuly imported."
    },
    badge: {
      model: "Badge",
      recommendedSize: "Printer Friendly SVG Badge size should be sepcified in CM or MM. Recommended size is A6 (105mm x 148mm)",
      name: "Badge Name",
      svg: "Badge SVG",
      fieldMapping: "Field Mapping",
      mapBadge: "Map Text values in your badge with registration data",
      newField: "New Field",
      cancel: {
        title: "Cancel Badge",
        body: `By cancelling this badge, the option will no longer be available to the public.<br>
              Past badges will not be affected. Cancelling a badge cannot be reversed.<br>`
      },
      chooseExisting: "Choose an existing badge:",
      disclaimer: "This badge will be available to print for the selected ticket types.",
      replace: "Replace",
      with: "With",
      textCase: "Text Case Transform",
      category: "Category",
      script: "Script"
    },
    discount: {
      model: "Discount",
      codeDisclaimer: "Discount Codes are case sensitive.",
      percentage: "Percentage",
      quantityDisclaimer: "How many times can this code be used.",
      cancel: {
        title: "Cancel Discount Code",
        body: `By cancelling this discount code, it will no longer be usable by the public.<br>
              Past discounts will not be affected. Cancelling a discount code cannot be reversed.<br>
              If you want to stop accepting this discount code, we recommend setting the quantity to “0” or the number of times it was used.`
      },
      code: "Code",
      status: "Status",
      import: "Import",
      downloadSample: "Download Sample File",
      type: "Type",
      discountCodes: "Discount Codes",
      importDiscounts: "Import Discounts",
      excelFile: "Excel File",
      plural: "Discounts",
      confirmImport: "Confirm",
      confirmDiscountCodeImport: "Confirm Discount Code Import"
    },
    donation: {
      model: "Donation",
      number: "Donation Number",
      advanced: "Advanced Donation Settings"
    },
    donationType: {
      model: "Donation Type",
      types: "Donation Types",
      eventDates: "Event Dates",
      disclaimer: "This donation type will be available for sale for any of the selected event dates.",
      donationAvailability: "Donation Availability",
      eventCover: "Use event cover photo",
      customCover: "Custom Cover Photo",
      blank: "Blank",
      recommendedSize: "Recommended image size of 1920px width by 640px height in JPG, PNG or GIF format.",
      cancel: {
        title: "Cancel Donation Type",
        body: `By cancelling this donation type, the option will no longer be available to the public.<br>
              Past donations will not be affected. Cancelling a donation type cannot be reversed.<br>
              If you want to stop collecting donations, we recommend setting the availability to “Hidden”`
      }
    },
    dynamicWhitelist: {
      ticketTypes: "Whitelist Ticket Types",
      ticketTypeRequires: " This ticket type %{type} bought for %{date} requires tickets from"
    },
    emailAttendees: {
      model: "Email To Attendees",
      new: "New Email",
      pluralized: "{count} Emails | {count} Email | {count} Emails",
      emails: "Emails",
      send: "Send",
      senderName: "Sender Name",
      sender: "Sender",
      sendTest: "Send Test",
      sendTestCopy: "Send a test copy to %{email}",
      content: "Content",
      sentOn: "Sent on"
    },
    eventSettings: {
      model: "Event Settings",
      publish: "Publish Event",
      eventDisclaimer: "Your event will become active and accessible to people.",
      requiresDiscountCode: "Discount Code",
      requiresDiscountCodeDisclaimer: "Discount code required to checkout.",
      limitUserOrders: "Limit orders per user",
      unlimited: "Unlimited",
      includeSummary: "Include Order Summary",
      includeTickets: "Include Tickets",
      cancel: "Cancel Event",
      cancelDisclaimer: "%{number} tickets were sold or issued for this event. By cancelling, this event, all tickets will be cancelled and purchases refunded to buyers.<br> Buyers will be immediately notified of the cancellation. This action cannot be reverted !",
      eventTicketsCanceledDisclaimer: "I understand all %{number} tickets will be cancelled and refunded when applicable.",
      cancelReason: "Cancel Reason",
      allowRegistrationFormEdit: "Allow Editing Registration Form",
      appliesToPaidOrders: "Only applies to paid orders",
      customConfirmationPage: "Custom Confirmation Page",
      hideReceipt: "Hide Receipt",
      hideTickets: "Hide Tickets",
      hideDownload: "Hide Download",
      customBookingMessage: "Custom Booking Message",
      customConfirmationMessage: "Custom Confirmation Message"
    },
    paymentSettings: {
      paymentMethodName: "Payment Method Name",
      paymentMethod: "Payment Method",
      paymentMethods: "Payment Methods",
      fees: "Fees",
      enableOrDisable: "Enable / Disable",
      absorbOrPassOn: "Absorb / Pass On",
      surcharge: "Surcharge",
      absorb: "Absorb",
      passOn: "Pass on",
      mapDisplay: "Fee Map Display",
      countries: "Countries",
      currencies: "Currencies",
      pluralized: "Payment Settings"
    },
    layout: {
      model: "Layout",
      seatingLayout: "Seating Layout",
      delete: "Delete Layout",
      sections: "Sections",
      seatedSections: "seated sections",
      nonSeatedSections: "non-seated sections",
      recommendedSize: "Recommended size of 1920px width by 960px height in SVG format",
      destroyDisclaimer: `N tickets were booked or sold. <br>
      By deleting this layout, all tickets issued with this seats will be affected.
      Make sure you understand the consequences of this action and contact the ihjoz team to plan your transition to a new seating map. <br>
      Deleting this layout cannot be reversed!`,
      seatingOverview: "Seating Overview",
      mapOverview: "Map Overview"
    },
    operaSettings: {
      enableIntegration: "Enable Opera Integration",
      domain: "Opera Domain",
      domainDisclaimer: "Override Glownet Opera's default domain with a custom domain.",
      apiKey: "API Key",
      operaEvent: "Opera Event",
      boxOffice: "Box Office",
      eventDisclaimer: "Select which event to connect with.",
      eventWallet: "Event Wallet",
      ticketLookup: "Ticket Lookup",
      tagLookup: "Tag Lookup",
      addTicket: "Add Ticket",
      addTag: "Add Tag",
      enableTransactionHistory: "Enable Transaction History",
      topupCurrency: "Topup Currency",
      suggestedAmount: "Suggested Topup Amount",
      allowTopups: "Allow Tag Topups",
      createNewTemplate: "Create New Default Template",
      showCurrencies: "Visible currencies",
      webhooks: "Webhooks",
      stations: "Stations",
      refundSection: "Refunds",
      enabledRefunds: "Enable Refunds",
      refundHours: "Hours",
      refundDays: "Days",
      refundMonths: "Months",
      refundAfter: "After",
      customSections: "Custom Sections",
      customSectionTitle: "Section Title",
      customSectionBody: "Content",
      newSection: "Add Custom Section",
      ticketingIntegration: "Ticketing Integration",
      syncronizeTicketTypes: "Syncronize Ticket Types and Tickets with Opera",
      requestForm: "Request Form",
      sync: "Opera Sync",
      walletSync: "Wallet Sync",
      syncOptions: "Wallet Sync Options",
      syncAllTicketTypes: "Sync All Ticket Types",
      enableCustomerTaxId: "Enable Customer Tax ID",
      AnonymousCustomerCreation: "Anonymous Customer Creation",
      registrationRequired: "Registration Required",
      onlineInitialTopupFee: "Online Initial Topup Fee",
      onlineRefundFee: "Online Refund fee",
      minimumOnlineRefund: "Minimum Online Refund",
      stations: "Stations",
      settle: "Settle"
    },
    order: {
      model: "Order",
      buyerRegistration: "Buyer Registration",
      email: "Email",
      emailOrMobile: "Email or Mobile Number",
      download: "Download Order",
      printBadge: "Print Badge",
      summary: "Order Summary"
    },
    orderReport: {
      model: "Orders Report",
      orders: "Orders",
      paymentStatus: "Payment Status",
      allDates: "All Event Dates",
      s6Report: "S6 Report",
      refund: "Refund",
      filterOrders: "Filter Orders",
      merchantId: "Merchant ID",
      dolphinReport: "VDolphin Report",
      resellerReport: "Reseller Report",
      orderFrom: "Order From",
      orderTo: "Order To",
      paymentFrom: "Payment From",
      paymentTo: "Payment To",
      orderId: "Order ID",
      orderDate: "Order Date",
      roundupFee: "Roundup Fee",
      paymentDate: "Payment Date",
      eventDateId: "Event Date ID",
      orderOwner: "Order Owner",
      createdBy: "Created By",
      clerkName: "Clerk Name",
      status: "Status",
      discountCode: "Discount Code",
      currencyId: "Event Currency ID",
      items: "Items",
      itemsTotal: "Items Total",
      donationAmount: "Donation Amount",
      serviceFeeVat: "Service Fee VAT",
      serviceFees: "Service Fees",
      feesAndVat: "Fees + VAT",
      paymentFees: "Payment Fees",
      resellerFee: "Reseller Fee",
      creditCardFee: "Credit Card Fee",
      targetCurrencyId: "Target Currency ID",
      targetCurrency: "Target Currency",
      exchangeRate: "Exchange Rate",
      conversionTime: "Conversion Timestamp",
      convertedTotal: "Converted Order Total",
      actions: "Actions",
      referrerCode: "Referrer Code"
    },
    partner: {
      model: "Partner",
      pluralized: "{count} Partners | {count} Partner | {count} Partners",
      delete: {
        title: "Delete Partner",
        body: `By confirming this deletion, this person/company will no longer appear on
              your list of partners.<br />
              Other partners will not be affected.`,
        button: "Delete"
      }
    },
    paymentConfirmation: {
      paymentOptions: "Payment Options",
      bookAndSend: "Book and Send Payment Instructions",
      cash: "Cash",
      card: "Credit Card",
      cheque: "Cheque",
      complimentary: "Complimentary",
      transactionReference: "Transaction Reference",
      emailConfirmation: "Email Payment Confirmation",
      orderConfirmation: "Order Confirmation"
    },
    paymentMethod: {
      unnamed: "Unnamed",
      model: "Payment Method",
      pluralized: "{count} Payment Methods | {count} Payment Method | {count} Payment Methods",
      name: "Payment Method Name",
      titleEn: "English Title",
      titleAr: "Arabic Title",
      rank: "Rank",
      feeMap: "Fee Map",
      feeMapEn: "English Fee Map Display",
      feeMapAr: "Arabic Fee Map Display",
      acceptExchange: "Accept Exchange From Base Currency",
      paymentPlugin: "Payment Plugin",
      merchantPayout: "Merchant Payout",
      tenantPayout: "Tenant Payout",
      tenantFees: "Tenant Fees",
      maxAmount: "Maximum Amount",
      expiry: "Expiration Period",
      existingBadges: "Existing Badges",
      title: "Title %{locale}",
      description: "Description",
      image: "Image",
      png: "PNG Image",
      public: "Public",
      enableTotalRoundup: "Enable total roundup",
      showPublicly: "Show Publicly",
      calcMerchant: "Calculate merchant payout",
      calcTenantPayout: "Calculate tenant payout",
      calcTenantFees: "Calculate tenant fees",
      visualOrderNumber: "Rank",
      paymentKeyMap: {
        publicKey: "Public Key",
        secretKey: "Secret Key",
        environment: "Environment",
        username: "Username",
        password: "Password",
        sourceCode: "Source Code",
        scriptSrc: "Script Source",
        apiUrl: "API URL",
        version: "version",
        merchantId: "Merchant ID",
        host: "Host",
        shopId: "Shop ID",
        shopPass: "Shop Pass",
        merchantName: "Merchant Name",
        authorizationType: "Authorization Type",
        hostedSessionToken: "Hosted Session Token",
        outletId: "Outlet ID",
        baseUrl: "Base URL",
        token: "Token",
        secretToken: "Secret Token",
        callbackToken: "Callback Token",
        clientId: "Client ID",
        clientSecret: "Client Secret"
      }
    },
    selectedPaymentPlugin: {
      schema: {
        publicKey: "Public Key",
        secretKey: "Secret Key",
        environment: "Environment",
        username: "Username",
        password: "Password",
        sourceCode: "Source Code",
        scriptSrc: "Script Source",
        apiUrl: "API URL",
        version: "version",
        merchantId: "Merchant ID",
        host: "Host",
        shopId: "Shop ID",
        shopPass: "Shop Pass",
        merchantName: "Merchant Name",
        authorizationType: "Authorization Type",
        hostedSessionToken: "Hosted Session Token",
        outletId: "Outlet ID",
        baseUrl: "Base URL",
        token: "Token",
        secretToken: "Secret Token"
      }
    },
    registration: {
      model: "Registration"
    },
    registrationForm: {
      model: "Registration Form",
      newQuestion: "New Question",
      questions: "Registration Questions",
      questionType: "Question Type",
      question: "Question",
      placeholderText: "Placeholder Text",
      instructions: "Instructions",
      waiverText: "Waiver Text",
      options: "Options",
      importBulkOptions: "Import Bulk Options",
      standardOptionEditor: "Standard Option Editor",
      editOptionsText: "Edit or copy your options in the correct order. Each option should be inputted on a separate line.",
      import: "Import",
      requiredQuestion: "Required Question"
    },
    reservation: {
      model: "Reservation",
      reservedSeats: "Reserved Seats",
      reservedSeatList: "Reserved Seat List"
    },
    section: {
      editSeating: "Edit Seating Section",
      seatingSections: "Seating Sections",
      name: "Section Name",
      seats: "Seats",
      color: "Color"
    },
    company: {
      newProfile: "New Profile",
      profilePicture: "Profile Picture",
      recommendedProfileSize: "Recommended image size of 256px width by 256px height in JPG, PNG or GIF format.",
      recommendedCoverSize: "Recommended image size of 1920px width by 640px height in JPG, PNG or GIF format.",
      contactDetails: "Contact Details",
      publicContactInfo: "This information will appear publicly to all visitors",
      website: "Website",
      address: "Address"
    },
    empowerment: {
      model: "Teammate",
      pluralized: "{count} Teammates | {count} Teammate | {count} Teammates",
      email: "Teammate Email",
      emailDisclaimer: "Teammate must have an {tenant} account with the provided email.",
      cancel: {
        title: "Remove Teammate",
        button: "Remove",
        text: "I understand that this user will no longer have access to this merchant account.",
        body: `Removing a teammate will prevent all access to this dashboard and all events linked to this merchant account.<br>
              Removing a teammate will not undo, cancel or delete any past actions conducted by this user.<br>
              Removing a teammate will not affect their existing {tenant} account.`
      },
      rights: "Rights",
      yourTeam: "Your Team"
    },
    merchantAccount: {
      model: "Merchant Account",
      legalAndFinancialInfo: "Merchant Legal and Financial Information",
      company: "Company",
      individual: "Individual",
      invoiceDisclaimer: "Invoices and other items will be issued in your name and will include your tax information when necessary.",
      location: "Business Location",
      locationDisclaimer: "You can only set your business location once. Make sure the correct country is selected. The country will affect supported currencies and available payment methods.",
      defaultCurrency: "Default Currency",
      identifier: "IDENTIFIER",
      value: "VALUE",
      vat: "VAT#",
      mof: "MOF#",
      cr: "CR#",
      taxName: "TAX NAME",
      rate: "RATE",
      primaryContact: "Primary Contact",
      primaryContactText: "Contact Details and address of the person responsible for handling this account",
      settlementDetails: "Settlement Details",
      settlementSubtitle: "Your IBAN must be in the same country as your business location.If you are receiving payments in Lebanon, those payments can only be redeemed electronically in Lebanon.",
      preferredSettlementMethod: "Preferred Settlement Method",
      bankTransfer: "Bank Transfer",
      check: "Check",
      bankNumber: "Bank Number (IBAN)",
      iban: "IBAN",
      selectedCountryNotice: "You have selected %{country} as your business location. You will not be able to change your country after saving.",
      legalName: "Legal Name",
      fullName: "Full Name",
      taxRegTitle: "Tax Identifiers and Registration Numbers",
      taxRegSubtitle: "Add any required Identifiers or Registration Numbers (ie: VAT identification Numbers, MOF Numbers...) according to your local regulations to be featured on your invoices when required.",
      taxRateTitle: "Taxes and Rates",
      taxRateSubtitle: "Add any tax you are subject to in your country. Make sure to reference and update the tax rate as necessary. Include your Tax Number or ID to feature it on your customer invoices and attach any relevant certificate."
    },
    payout: {
      model: "Merchant Payout",
      new: "Request Payout",
      request: "Payout Request",
      payoutRequestText: "Submit a payout request to our accounting department to trigger your next payout. Your payout will cover the balance of your revenues collected by Fawter since your last payout net of all applicable fees.",
      optionalMessage: "Optional Message",
      requestPayout: "Request a Payout",
      noMobileNumber: "No mobile number",
      message: "Message"
    },
    settings: {
      notificationSettings: "Notification Settings",
      emailDisclaimer: "Receive notifications on this address",
      receiveNotifications: "Receive Notifications on",
      operaIntegration: "Opera Integration",
      enableOperaIntegration: "Enable Opera integration",
      paidOrders: "Paid Orders",
      smsOriginator: "SMS Originator",
      smsDisclaimer: "Up to 11 letters or numbers (no spaces) from which SMS notifications will be sent",
      defaultTemplates: "Default Templates"
    },
    setup: {
      createMerchantProfile: "Create a Merchant Profile",
      createMerchantAccount: "Create a Merchant Account",
      createInvoiceTemplate: "Create an Invoice Template"
    },
    user: {
      personalInfo: "Personal Information",
      personalInfoSubtitle: "Your profile information is used to register your tickets and purchases with merchants.",
      primaryEmailText: "Login with any verified email and receive notifications on your primary email. Set your primary email by moving it to the top of the list.",
      addEmail: "Add Email",
      mobileText: "Login with any verified mobile and receive notifications on your primary mobile. Set your primary mobile by moving it to the top of the list.",
      addMobile: "Add Mobile",
      timeZone: "Time Zone",
      locale: "Locale",
      nationality: "Nationality",
      delete: {
        title: "Delete Account",
        text: "I understand.",
        body: `We’re sorry to see you go. By deleting this account, you will lose access to any purchase or ticket you have conducted.<br>
        All personally identifying data will be deleted from our servers and this account will be permanently disabled.`
      },
      verified: "Verified",
      notVerified: "Not Verified",
      resendVerification: "Resend Verification Email",
      deleteEmail: "Delete This Email",
      deleteEmailText: "By deleting this email you will no longer be able to use it to login to your ihjoz account.",
      toDeleteEmailText: "To delete this email, make sure to add another email and set it as primary to preserve access to your account.",
      confirmDeleteText: " I understand, delete this email.",
      deleteEmailButton: "Delete Email",
      emailAddress: "Email Address",
      emailVerificationText: "You will receive an email containing a verification link. Please click on the link to complete verify ownership of this email address.",
      verifyMobile: "Verify Mobile Number",
      resendCode: "Resend Verification Code",
      deleteMobile: "Delete This Mobile Number",
      deleteMobileText: "By deleting this mobile number you will no longer be able to use it to login to your ihjoz account.",
      toDeleteMobileText: " To delete this mobile number, make sure to add another mobile number and set it as primary to preserve access to your account.",
      confirmDeleteMobileText: " I understand, delete this mobile number.",
      deleteMobileButton: "Delete Mobile Number",
      editMobile: "Edit Mobile Number",
      newMobile: "Add Mobile Number",
      smsVerification: "An SMS will be sent to you to verify ownership of this mobile number. Input the verification code you receive by SMS.",
      changePass: "Change Password",
      strongPassText: "Set a strong, 8+ character password to protect your account.",
      currentPass: "Current Password",
      newPass: "New Password",
      confirmPass: "Confirm New Password",
      passwordValidation: {
        letters: "Needs at least one lowercase and uppercase letter",
        number: "Needs at least one number",
        special: "Needs at least one special character",
        length: "Needs to be at least 8 characters long",
        veryWeak: "Very Weak",
        weak: "Weak",
        moderate: "Moderate",
        great: "Great!",
        passwordConfirmationMismatch: "Password Confirmation doesn't match the new Password"
      }
    },
    userEmail: {
      email: "Email"
    },
    wallet: {
      filterWallets: "Filter Wallets",
      walletId: "Wallet ID",
      userId: "User ID",
      customerFirstName: "Customer First Name",
      customerLastName: "Customer Last Name",
      customerEmail: "Customer Email",
      customerTaxId: "Customer Tax ID",
      tickets: "Tickets Codes",
      tags: "Tags UIDs",
      standardBalance: "Standard Balance",
      topupFeePaid: "Initial Topup Fee Paid ?",
      externalId: "External ID",
      createdAt: "Created At",
      updatedAt: "Updated At",
      claimedRefundAt: "Claimed Refund At",
      wallets: "Wallets",
      walletsPluralized: "Wallets | Wallet | Wallets",
      refundRequestsPluralized: "Refund Requests | Refund Request | Refund Requests",
      model: "Wallet Report",
      accountHolderFirstName: "Account Holder First Name",
      accountHolderLastName: "Account Holder Last Name",
      idCardNumber: "Id Card Number",
      postCode: "Post Code",
      iban: "Iban",
      bsb: "BSB",
      sortCode: "Sort Code",
      accountNumber: "Account Number",
      achRoutingNumber: "Ach Routing Number",
      wireRoutingNumber: "Wire Routing Number",
      bankName: "Bank Name",
      bankAddress: "Bank Address",
      swiftOrBic: "Swift Or Bic",
      refundRequests: "Refund Requests"
    },
    operaStation: {
      model: "Station",
      pluralized: "{count} Stations | {count} Station | {count} Stations",
      resync: "Resync",
      connectedMerchantAccount: "Connected Merchant Account"
    },
    integration: {
      model: "Integration",
      pluralized: "{count} Integrations | {count} Integration | {count} Integrations",
      plural: "Integrations",
      name: "Name",
      production: "Production",
      sandbox: "Sandbox",
      enabled: "Enabled",
      enabledIntegrations: "Enabled Integrations",
      availableIntegrations: "Available Integrations"
    }
  }
};
